import React from 'react'
import { Box, Checkbox, Wrap, WrapItem } from '@chakra-ui/react'

export default function Choice ({ dataType, value, onChange }) {
  const localOnChange = val => {
    let newValue = Object.assign([], value)
    if (dataType?.multiple) {
      if (newValue.includes(val)) {
        newValue.splice(newValue.indexOf(val), 1)
      } else if (val === 'none') {
        newValue = ['none']
      } else {
        if (newValue.includes('none')) {
          newValue.splice(newValue.indexOf('none'), 1)
        }
        newValue.push(val)
      }
    } else {
      if (newValue.includes(val)) {
        newValue = []
      } else {
        newValue = [val]
      }
    }
    onChange(newValue)
  }

  return (
    <Box>
      <Wrap spacing={4}>
        {dataType?.options?.map((option, index) => (
          <WrapItem key={index}>
            <Checkbox isChecked={value?.includes(option)} onChange={() => localOnChange(option)}>{option}</Checkbox>
          </WrapItem>))}
        {dataType?.includeNone &&
          <WrapItem>
            <Checkbox color='orange.600' mr={5} mb={5} isChecked={value?.indexOf('none') > -1} onChange={e => localOnChange('none')}>None</Checkbox>
          </WrapItem>}
      </Wrap>
    </Box>
  )
}
